<template>
	<button @click.stop="skip(duration)" class="flex items-center fill-current cursor-pointer self-center select-none">
		<!-- Skip Back -->
		<svg v-if="duration < 0" version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512; width: 18px; height: 18px; fill: inherit;" xml:space="preserve">
		<path d="M106.2,5l9.2,4c6.1,2.6,8.9,9.7,6.2,15.8L109.8,52c69-50.2,162-63.6,245.9-26.8C480.5,80,537.9,226.6,483.3,351.6
			c-54.7,125.4-200.7,182.7-326.2,128.2C98.5,454.2,54.7,408.8,30.2,354.9c-2.8-6.3,0.1-13.7,6.5-16.2L46,335
			c5.9-2.3,12.7,0.4,15.3,6.2c21.1,46.4,58.9,85.4,109.4,107.4c108,47,234.3-2.1,281.6-110.9c47-108-2.1-234.3-110.9-281.6
			c-76-33-160.7-18.5-220.8,30.5l32.4,14.1c6.1,2.6,8.9,9.7,6.2,15.8l-4,9.2c-2.6,6.1-9.7,8.9-15.8,6.2L65.1,99.5
			c-6.1-2.6-8.9-9.7-6.2-15.8l31.5-72.4C93,5.2,100.1,2.4,106.2,5z"/>
		<rect x="135" y="166" style="fill: none;" width="302" height="204"/>
		<text transform="matrix(1 0 0 1 135 351.4971)" style="font-family:'Montserrat-Medium'; font-size:250px;">{{ duration*-1 }}</text>
		</svg>
		<!-- Skip forward -->
		<svg v-else version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512; width: 18px; height: 18px; fill: inherit;" xml:space="preserve">
		<path d="M417.3,5l-9.5,4c-6.3,2.6-9.2,9.7-6.4,15.8L413.6,52C342.3,1.8,246.1-11.6,159.4,25.2C30.4,80-29,226.6,27.5,351.6
			C84,477,235,534.3,364.7,479.8c60.6-25.6,105.9-71,131.2-124.9c2.9-6.3-0.1-13.7-6.7-16.2l-9.6-3.7c-6.1-2.3-13.1,0.4-15.8,6.2
			c-21.8,46.4-60.9,85.4-113.1,107.4c-111.7,47-242.2-2.1-291.1-110.9c-48.6-108,2.2-234.3,114.7-281.6c78.6-33,166.1-18.5,228.3,30.5
			l-33.5,14.1c-6.3,2.6-9.2,9.7-6.4,15.8l4.1,9.2c2.7,6.1,10,8.9,16.3,6.2l76.8-32.4c6.3-2.6,9.2-9.7,6.4-15.8l-32.6-72.4
			C431,5.2,423.6,2.4,417.3,5z"/>
		<rect x="135" y="166" style="fill:none;" width="302" height="204"/>
		<text transform="matrix(1 0 0 1 135 351.4971)" style="font-family:'Montserrat-Medium'; font-size:250px;">{{ duration }}</text>
		</svg>
	</button>
</template>

<script>
export default {
	props: ['duration', 'player'],
	methods: {
		skip(skipTime) {
			let player = this.player
			if (!player) return
			// Both ends. Only the upper bound was clamped, so "back 15" inside
			// the first 15 seconds assigned a negative currentTime — Safari
			// throws IndexSizeError on that and the click did nothing at all.
			// `duration` is NaN until metadata loads; fall back to the raw sum
			// rather than propagating NaN into currentTime.
			let target = player.currentTime + skipTime
			if (Number.isFinite(player.duration)) target = Math.min(target, player.duration)
			player.currentTime = Math.max(0, target)
		},
	}
}
</script>
